import React from 'react'

import { CopyLinkInput } from '@components/common/CopyLinkInput'

import type { Incentive as IncentiveType } from '../../../../Recommendations.types'
import { useReferralConfigurationQuery } from '../../../../queries/useReferralConfigurationQuery'
import * as S from '../Incentive/styled'

type Props = {
  incentive: Extract<IncentiveType, { type: 'DOUBLE_SIGNUP_REFERRAL_BONUS' }>
}

export const DoubleReferralBonusIncentive = ({ incentive }: Props) => {
  const { referralConfigurationQuery } = useReferralConfigurationQuery([{ pathOverride: 'try' }], {
    onError: undefined,
  })
  const link = referralConfigurationQuery.data?.shortLink || ''

  return (
    <S.Container completed={incentive.isCompleted} id="doubleReferralBonusIncentive">
      <S.Title style={{ width: '100%' }}>
        {link ? (
          <CopyLinkInput href={link} analytics="campaignDoubleReferralBonus" />
        ) : (
          'Loading referral link...'
        )}
      </S.Title>
    </S.Container>
  )
}
